export const TimeFormat = "HH:mm"; // 15:03
export const FullDateFormat = "dd/MM/yyyy"
export const DateFormat = "dd/MM/yy"; // 04/01/23
export const DateTimeFormat = `${TimeFormat} ${DateFormat}`; //15:03 04/01/23
export const DateFormat2 = "dd MMMM yyyy"; // 04 January 2023
export const DateFormat3 = "MMM yy"; // Jan 23
// export const Date3 = "dd/MM/yyyy"; // 04/01/2023
// export const Date4 = "d MMM yy"; // 4 Jan 23
